import {AxiosError, AxiosRequestConfig} from "axios"
import AuthStore from "@/store/AuthStore"
import {RootRoute, RootRouter} from "@/router"

export class CommonApi {
  static catchHandler<T = any>(reason: AxiosError): Promise<T> {
    if (reason.response && reason.response.status == 401) {
      // Unauthorized
      AuthStore.module.logout()
      RootRouter.push(RootRoute.loginFromCurRoute())
      return Promise.reject("Redirected to login form")

    } else if (reason.response) {
      alert("Error response from server:\n" + reason.response.status + ": " + reason.response.statusText + "\n\n" + reason.response.data)
    } else if (reason.message) {
      alert("Error response from server:\n" + reason.message)
    }
    return Promise.reject(reason)
  }

  static requestConfig(): AxiosRequestConfig {
    const token = AuthStore.module.token
    if (token) {
      return {
        headers: {Authorization: `Bearer ${token}`}
      }
    }
    return {}
  }
}
